import { TopPage } from "@/components/elements/TopPage";
import { Stack, Box } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { matchRoutes, Outlet, useLocation, useParams } from "react-router-dom";
import { settingMenu } from "@/features/system-setting/constants/settingMenu";
import { GenericTabs } from "@/components/commons/GenericTabs";

type TSettingLayoutProps = {};

export const SettingLayout: FC<TSettingLayoutProps> = () => {
  const { id } = useParams();
  const { pathname } = useLocation();

  const activeIndex = settingMenu.findIndex(({ url }) => matchRoutes([{ path: url }], pathname) !== null);

  const [value, setValue] = useState(activeIndex !== -1 ? activeIndex : 0);

  useEffect(() => {
    setValue(activeIndex !== -1 ? activeIndex : 0);
  }, [activeIndex]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Stack sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <TopPage title="システム設定" enablePageBack={false} />
      </Box>

      <GenericTabs tabs={settingMenu.map(({ title, url }) => ({ label: title, url }))} value={value} onChange={handleChange} id={id} />

      <Outlet />
    </Stack>
  );
};
